// extracted by mini-css-extract-plugin
export default {"change-password-box":"change-password_change-password-box__0BHbh","change-password-button":"change-password_change-password-button__yR0li"};